import React, { useEffect, useState } from "react";
import "./App.css";
import {
  parseAppUrl,
  replaceUrl,
  type AppUrlState,
} from "./lib/appUrl";
import HomePage from "./pages/HomePage";
import MemoryTabsPage from "./pages/MemoryTabsPage";
import type { MemoryTab } from "./types/memory";

function readUrlState(): AppUrlState {
  return parseAppUrl(window.location.search);
}

const App: React.FC = () => {
  const [state, setState] = useState<AppUrlState>(readUrlState);

  useEffect(() => {
    const onPop = () => setState(readUrlState());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const goHome = () => {
    const next: AppUrlState = { view: "home" };
    setState(next);
    replaceUrl(next);
  };

  const goMemories = (tab: MemoryTab) => {
    const next: AppUrlState = { view: "memories", tab };
    setState(next);
    replaceUrl(next);
  };

  return (
    <div className="App min-h-screen bg-gray-50">
      {state.view === "home" ? (
        <HomePage onEnter={() => goMemories("anniversary")} />
      ) : (
        <MemoryTabsPage
          tab={state.tab}
          onTabChange={(tab) => goMemories(tab)}
          onBack={goHome}
        />
      )}
    </div>
  );
};

export default App;
